import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Input,
  Stack,
  FormLabel,
  Button,
  Text,
  Avatar,
  Grid,
  Select,
} from "@chakra-ui/react";
import React, { useRef } from "react";

let profileCompleted = false;

export default function EditProfileDrawer({ isOpen, onClose }) {
  const firstField = useRef();

  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      initialFocusRef={firstField}
      onClose={onClose}
      size="sm"
    >
      <DrawerOverlay>
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader py={12} mx={6} borderBottomWidth="1px">
            <Grid templateColumns="1fr 1fr" alignItems="center">
              <Text>{profileCompleted ? "Profile" : "Complete Profile"}</Text>
              <Box sx={{ textAlign: "center", cursor: "pointer" }}>
                <Avatar bg="teal.500" size="lg" />
                <Text sx={{ fontSize: "14px", mt: 3, fontWeight: "300px" }}>
                  Tap to change
                </Text>
              </Box>
            </Grid>
          </DrawerHeader>

          <DrawerBody mt={8}>
            <Stack spacing="24px">
              <Box>
                <FormLabel htmlFor="orgName">Organization Name</FormLabel>
                <Input id="orgName" />
              </Box>

              <Box>
                <FormLabel htmlFor="adminFirstName">Admin First Name</FormLabel>
                <Input id="adminFirstName" />
              </Box>

              <Box>
                <FormLabel htmlFor="adminLastName">Admin Last Name</FormLabel>
                <Input id="adminLastName" />
              </Box>

              <Box>
                <FormLabel disabled={!profileCompleted} htmlFor="email">
                  Email Address
                </FormLabel>
                <Input id="email" />
              </Box>

              <Box>
                <FormLabel htmlFor="phone" disabled={!profileCompleted}>
                  Phone Number
                </FormLabel>
                <Input id="phone" />
              </Box>
              <Box>
                <FormLabel htmlFor="industry" disabled={!profileCompleted}>
                  Industry
                </FormLabel>
                <Select id="industry">
                  <option>Education</option>
                </Select>
              </Box>
            </Stack>
          </DrawerBody>

          <DrawerFooter borderTopWidth="1px">
            <Button isFullWidth my={4} colorScheme="blue">
              {profileCompleted ? "Update Profile" : "save"}
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
}
